import { useState } from "react";
import api, { formatApiError } from "@/lib/api";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
    const [state, setState] = useState("idle");
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setState("loading");
        setErr("");
        try {
            await api.post("/contact", form);
            setState("ok");
        } catch (e) {
            setState("idle");
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        }
    };

    return (
        <div className="content-page" data-testid="contact-page">
            <div className="eyebrow" style={{ marginBottom: 12 }}>Contact</div>
            <h1>Talk to <em>us.</em></h1>
            <p className="lede">
                Curation questions, consignment queries, or press — a real person will reply.
            </p>

            <div className="two-col">
                <section>
                    <h2 style={{ fontStyle: "italic" }}>Say hello</h2>
                    {state === "ok" ? (
                        <div style={{ padding: "24px 0", fontFamily: "var(--font-serif)", color: "var(--cocoa)" }} data-testid="contact-success">
                            Thank you — we&rsquo;ll be in touch shortly.
                        </div>
                    ) : (
                        <form onSubmit={onSubmit} data-testid="contact-form">
                            <div className="field">
                                <label className="label">Name</label>
                                <input className="input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
                            </div>
                            <div className="field">
                                <label className="label">Email</label>
                                <input className="input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
                            </div>
                            <div className="field">
                                <label className="label">Message</label>
                                <textarea className="input" rows="5" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
                            </div>
                            <input
                                type="text"
                                name="website"
                                tabIndex="-1"
                                autoComplete="off"
                                value={form.website}
                                onChange={(e) => setForm({ ...form, website: e.target.value })}
                                style={{ position: "absolute", left: "-9999px", opacity: 0, height: 0, width: 0 }}
                                aria-hidden="true"
                            />
                            {err && <div className="form-error">{err}</div>}
                            <button className="btn" type="submit" disabled={state === "loading"} data-testid="contact-submit">
                                {state === "loading" ? "Sending…" : "Send"}
                            </button>
                        </form>
                    )}
                </section>

                <section>
                    <h2 style={{ fontStyle: "italic" }}>Or write directly</h2>
                    <p>
                        <a href="mailto:hello@raxtheedit.com" className="link-underline">hello@raxtheedit.com</a>
                    </p>
                    <p style={{ marginTop: 24 }}>
                        RAX The Edit
                        <br />
                        London
                    </p>
                    <p style={{ marginTop: 24, fontStyle: "italic" }}>
                        A real reply, usually within a day.
                    </p>
                </section>
            </div>
        </div>
    );
}
